import { UIElement } from '../ui-element';
import styles from './ui-products.css';
import { createElement } from '../../global/render-api';
import { Component } from '../../decorators/component.decorator';
import { Attribute } from '../../decorators/attribute.decorator';
import { TranslationLabels } from '../../types/labels.type';
import { Children } from '../../decorators/child.decorator';
import { UIProduct } from './ui-product';
import { CMS_CONTENT_MODES } from '../../cms';

type UIProductsLayout = 'default' | 'offer';

/**
 * @class
 * @memberof SharedComponents
 * @augments {UIElement}
 * @alias UIProducts
 * @element ui-products
 * @classdesc Represents a class for <code>ui-products</code> element.
 * Container for <b>&lt;ui-product></b>. This element should contain only
 * <b>&lt;ui-product><b> elements.
 * @property {string} [label] {@attr label} Heading before section.
 * @property {UIProductsLayout} [layout=""] {@attr layout} Layout for products.
 *  {@desc offer: displays background as offer}
 * @slot {@type "ui-product"}
 * @example
 * <ui-products label="Related products">
 *   <ui-product title="Casco insurance" icon="transport">
 *     <p>This is a cool product</p>
 *   </ui-product>
 *   <ui-product title="Home insurance" icon="home">
 *     <p>This is a cool product</p>
 *   </ui-product>
 *   <ui-product title="Travel insurance" icon="sun">
 *     <p>This is a cool product</p>
 *   </ui-product>
 * </ui-products>
 */
@Component({
    tag: 'ui-products',
    styles,
    cms: {
        mode: CMS_CONTENT_MODES.Children,
        allowedChildren: ['ui-product'],
    },
})
export class UIProducts extends UIElement {
    @Attribute(String) label?: TranslationLabels.Label;
    @Attribute(String) layout?: UIProductsLayout;
    @Children('ui-product') productElements!: Array<UIProduct>;

    /**
     * @inheritDoc
     */
    render() {
        this.setAttribute('role', 'list');
        if (this.label) {
            const header = createElement({
                tagName: 'h2',
                classList: {
                    'ui-products__heading': true,
                },
                children: [this.label],
            })!;
            this.insertAdjacentElement('beforebegin', header);
        }
    }
}
